const EVENT_HELPER = {
    TEMPORARY_USER_TRAITS: 'temporary-user-traits',
}

const BUSINESS_VERTICAL = {
  GROCERY: 'grocery',
}

const EVENT_CATEGORY = {
  GROCERY: 'grocery',
  PROMOTION_COLLECTION: 'promotion collection',
  VOUCHER: 'voucher',
  ACCOUNT: 'account',
  PAYMENT: 'payment',
  CHECKOUT: 'checkout',
}

const BUTTON_NAME_MYINFO_CONTINUE = 'myinfo continue'
const BUTTON_NAME_POA_INITIATED = 'poa initiated'
const BUTTON_NAME_SWIMLANE_SEE_ALL = 'swimlane see all'
const BUTTON_NAME_PLACE_ORDER = 'place order'
const BUTTON_NAME_VOUCHER_ADD = 'voucher add'
const BUTTON_TYPE_LINK_STYLE = 'link style'


export {
    EVENT_HELPER,
    BUSINESS_VERTICAL,
    EVENT_CATEGORY,
    BUTTON_NAME_MYINFO_CONTINUE,
    BUTTON_NAME_SWIMLANE_SEE_ALL,
    BUTTON_NAME_PLACE_ORDER,
    BUTTON_NAME_POA_INITIATED,
    BUTTON_NAME_VOUCHER_ADD,
    BUTTON_TYPE_LINK_STYLE
}